import { render } from "./oncall-errorreport.vue?vue&type=template&id=166fd281"
import script from "./oncall-errorreport.vue?vue&type=script&lang=js"
export * from "./oncall-errorreport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__